const Loader = () => {
  return (
    <div className="loading-spinner-wrap">
      <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
    </div>
  )
}

export default Loader;